import type { IWorkshop } from "@bbj-types/workshop";
import { useCallback } from "react";
import { workshopsAxios } from "./axios";

export interface ISearchWorkshopsForParticipantsBody {
  startDate: Date;
  endDate: Date;
}

export type TSearchWorkshopsForParticipants = (Pick<
  IWorkshop,
  | "_id"
  | "sessionType"
  | "address"
  | "organizer"
  | "date"
  | "startTime"
  | "endTime"
  | "isDone"
  | "mainAnimator"
  | "otherAnimators"
> & {
  presenceTime?: IWorkshop["participants"][number]["presenceTime"];
  isPresent: IWorkshop["participants"][number]["isPresent"];
})[];

export const useSearchWorkshopsForParticipants = () => {
  const [state, execute, cancel] = workshopsAxios<TSearchWorkshopsForParticipants, ISearchWorkshopsForParticipantsBody>(
    {
      method: "POST",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateId: string, query: ISearchWorkshopsForParticipantsBody) => {
      return execute({
        url: `/search/participants/${candidateId}`,
        params: query,
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
